import { Trash } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import Tooltip from "ds/components/Tooltip";

import { ANALYTICS } from "../../constants";
import { CellComponentProps } from "../../types";
import { showDeleteConfirmation } from "./DeleteConfirmation";

type PermissionsListItemDeleteActionsCellProps = CellComponentProps;

const PermissionsListItemDeleteActionsCell = ({
  permission,
  readOnly,
}: PermissionsListItemDeleteActionsCellProps) => {
  if (readOnly) {
    return null;
  }

  return (
    <Tooltip
      active={!!permission.deleteDisabledMessage}
      on={(props) => (
        <ButtonIcon
          {...props}
          {...ANALYTICS}
          variant="dangerSecondary"
          analyticsTitle="Delete clicked"
          icon={Trash}
          disabled={!!permission.deleteDisabledMessage}
          onPress={() => showDeleteConfirmation({ permission })}
        >
          Delete
        </ButtonIcon>
      )}
    >
      {permission.deleteDisabledMessage}
    </Tooltip>
  );
};

export default PermissionsListItemDeleteActionsCell;
